import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideIonicAngular({
      // Configuración para asegurar que todos los servicios de Ionic estén disponibles
      mode: 'md' // o 'ios' según tu preferencia
    })
  ]
};
